import { render, staticRenderFns } from "./SimpleRequisites.vue?vue&type=template&id=166eaf85&scoped=true&"
import script from "./SimpleRequisites.vue?vue&type=script&lang=js&"
export * from "./SimpleRequisites.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRequisites.vue?vue&type=style&index=0&id=166eaf85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166eaf85",
  null
  
)

export default component.exports